import { RouteLink, YumRoute } from '@mr-yum/frontend-core/dist/services/routes'
import { ArrowLeftIcon, Button } from '@mr-yum/frontend-ui'
import { useRouter } from 'next/router'
import React, { useCallback } from 'react'

import { NavBar } from '@/components/Common/NavBar'

export interface NavBarProps {
  title?: React.ReactNode
  backRoute?: YumRoute<any>
  pathData?: any
  showBack?: boolean
  onBack?: () => void
  icon?: React.ReactNode
  left?: React.ReactNode
  right?: React.ReactNode
}

export const CartNavBar = ({
  title,
  backRoute,
  pathData,
  showBack = true,
  onBack,
  icon = <ArrowLeftIcon />,
  left = <div className="h-full w-14" data-testid="left"></div>,
  right = <div className="h-full w-14" data-testid="right"></div>,
}: NavBarProps) => {
  const { back } = useRouter()

  const handleOnBack = useCallback(() => {
    if (onBack) {
      onBack()
      return
    }
    back()
  }, [back, onBack])

  let leftElement = left

  if (showBack && backRoute) {
    leftElement = (
      <RouteLink route={backRoute} pathData={pathData}>
        <Button
          variant="ghost-secondary"
          as="a"
          className="h-14 rounded-none border-0 bg-transparent py-3 text-foreground-ui-navbar hover:bg-transparent"
          data-testid="back-route"
        >
          {icon}
        </Button>
      </RouteLink>
    )
  } else if (showBack) {
    leftElement = (
      <Button
        variant="ghost-secondary"
        type="button"
        onClick={handleOnBack}
        className="h-14 rounded-none border-0 bg-transparent py-3 text-foreground-ui-navbar hover:bg-transparent"
        data-testid="show-back"
      >
        {icon}
      </Button>
    )
  }

  return <NavBar left={leftElement} title={title} right={right} />
}
